import { Dispatch } from 'redux';
import { IOrderExclusion } from '../../../models/OrderExclusions.model';
import { OrderExclusionContants } from './orderExclusionConstants';
import * as Actions from './orderExclusionsActions';
import OrderExclusionService from '../../../services/orderExclusionService';

export function createOrderExclusionRequest(): Actions.FetchExclusionsList {
  return {
    type: OrderExclusionContants.GET_ORDER_EXCLUSIONS_REQUEST,
  };
}
export function createOrderExclusionSuccess(
  payload: Array<IOrderExclusion>
): Actions.FetchExclusionsList.Success {
  return {
    type: OrderExclusionContants.GET_ORDER_EXCLUSIONS_SUCCESS,
    orderExclusions: payload,
  };
}

export function createOrderExclusionFailure(
  error: string
): Actions.FetchExclusionsList.Failure {
  return {
    type: OrderExclusionContants.GET_ORDER_EXCLUSIONS_FAILURE,
    error,
  };
}

export function loadOrderExclusions(
  customerId: number,
  ignoreCache: boolean = false
): (dispatch: Dispatch<Actions.All>) => Promise<void> {
  return async function (dispatch: Dispatch<Actions.All>): Promise<void> {
    dispatch(createOrderExclusionRequest());
    try {
      const result: Array<IOrderExclusion> =
        await OrderExclusionService.getExclusions(customerId, ignoreCache);
      dispatch(createOrderExclusionSuccess(result));
    } catch (error) {
      dispatch(createOrderExclusionFailure(error));
    }
  };
}
